/* eslint-disable no-underscore-dangle */
/* eslint-disable import/named */
/* eslint-disable no-console */
import { put, takeLatest, select } from 'redux-saga/effects';
import moment from 'moment';
import { compact, uniq, last } from 'lodash';
import WORKFLOW from 'containers/CRM/OrderItemsContainer/OrderItemView/workflow';
import { QUALITY_BG_COLORS, setNotification } from 'utils';
import {
    loadReprintRes,
    loadReprintErr,
    ignoreReprintRes,
    ignoreReprintErr,
} from '../actions/reprintActions';
import { IGNORE_REPRINT, LOAD_REPRINT } from '../types/reprintTypes';
import { getOverviewApi } from '../api/packagingApi';
import { getFormsApi } from '../api/formApi';
import { getFormVersionsApi } from '../api/formVersionApi';
import { getAllJobResultsApi } from '../api/jobResultApi';
import { reprintStateApi } from '../api/orderItemApi';

const getReprint = state => state.reprint;
const getLayout = state => state.layout;

// L O A D   P R E P R E S S
function* loadReprintSaga() {
    const { offset, limit, filters, sort } = yield select(getReprint);

    try {
        const params = { limit, offset };

        if (sort !== null) {
            const sortInt = sort.type === 'asc' ? 1 : -1;

            if (sort.key === 'quantity') {
                params.sort_by = JSON.stringify({ quantity: sortInt });
            } else if (sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            } else if (sort.key === 'status') {
                params.sort_by = JSON.stringify({ status: sortInt });
            }
        }

        const sendFilters = {
            or: [
                {
                    and: [
                        {
                            error_quantity: { gt: 0 },
                            compareFields: { operator: 'lt', fields: ['last_step_quantity', 'quantity_minimum'] },
                            item_id: { ne: null },
                        },
                    ],
                },
                // { error_quantity: { gte: 1 }, step_quantity_print: 1, step_quantity_cutting: 0 },
                { 'reprint_requests.state': 'NEW' },
            ],
        };

        if (filters.customer !== '') {
            sendFilters.customer_name = {
                operator: 'typing',
                value: filters.customer,
            };
        }

        if (filters.size !== '') {
            sendFilters['configurations.configurations_property.name.value'] = {
                operator: 'typing',
                value: filters.size,
            };
        }

        if (filters.carpetQuality !== '') {
            sendFilters['configurations.configurations_property.name.value'] = {
                operator: 'typing',
                value: filters.carpetQuality,
            };
        }

        if (filters.orderItemId !== '') {
            sendFilters.order_item_number = {
                operator: 'typing',
                value: filters.orderItemId,
            };
        }

        if (filters.orderId !== '') {
            sendFilters.order_number = {
                operator: 'typing',
                value: filters.orderId,
            };
        }

        if (filters.state !== undefined) {
            sendFilters.state = filters.state;
        }

        if (filters.reprint_state !== undefined) {
            sendFilters.reprint_state = filters.reprint_state;
        }

        if (filters.designId !== '') {
            sendFilters.design_id = {
                operator: 'typing',
                value: filters.designId,
            };
        }

        if (filters.quantity !== '') {
            sendFilters.quantity = parseInt(filters.quantity, 10);
        }

        if (filters.expectedEndDate) {
            sendFilters.expected_shipping_date = moment.utc(filters.expectedEndDate).format('YYYY-MM-DD 00:00:00');
        }

        params.filter = JSON.stringify(sendFilters);
        const result = yield getOverviewApi(params);

        if (result.status === 200) {
            const { hits } = result.data;

            const orderItemNumbers = uniq(compact(hits.map(hit => hit.order_item_number)));
            const orderItemIDS = uniq(compact(hits.map(hit => hit._id)));

            const resultForm = yield getFormsApi({
                filter: JSON.stringify({ po_number: orderItemNumbers }),
                limit: orderItemNumbers.length * 3,
            });

            const resultFormVersion = yield getFormVersionsApi({
                filter: JSON.stringify({ form_id: resultForm.data.hits.map((hit => hit._id)) }),
                joins: JSON.stringify(['rolls_outs', 'form']),
                limit: resultForm.data.hits.length * 4,
            });

            const resultJobResult = yield getAllJobResultsApi({
                filter: JSON.stringify({ order_item_id: orderItemIDS }),
                limit: orderItemIDS.length * 2,
            });

            yield put(loadReprintRes({
                ...result.data,
                hits: hits.map((hit) => {
                    const formVersion = resultFormVersion.data.hits.find(fv => fv.form[0].po_number.includes(hit.order_item_number));

                    const [qualityConfiguration] = hit.configurations;

                    const quality = qualityConfiguration.configurations_property.find(cp => cp.type.toLowerCase() === 'quality');
                    const border = qualityConfiguration.configurations_property.find(cp => cp.type.toLowerCase() === 'border');

                    let borderName = '';
                    if (border) {
                        if (border.code === '1') {
                            borderName = ', with Border';
                        }
                    }

                    const workflowKey = `${border?.code !== '0' ? 'b' : ''}${quality?.code}`;

                    const steps = WORKFLOW[workflowKey];
                    const lastStep = last(steps);

                    let list = [];

                    const jobResults = resultJobResult.data?.hits || [];

                    if (lastStep?.machine_id === process.env.REACT_APP_MACHINE_COATING_IN_LINE) {
                        list = jobResults.filter(jr => jr.order_item_id === hit._id).filter(jr => (
                            !!(jr.steps_tracking || []).find(st => st.machine_id === process.env.REACT_APP_MACHINE_COATING_IN_LINE && st.state === 'DONE')
                        ));
                    } else {
                        list = (jobResults || []).filter(jr => jr.order_item_id === hit._id)
                            .filter((jr) => {
                                if (lastStep?.machine_id === process.env.REACT_APP_MACHINE_CUTTING) {
                                    return jr.parent === null;
                                }

                                return jr.parent !== null;
                            });
                    }

                    const countJr = list.reduce((acc, curr) => acc + curr.quantity, 0);

                    const count = (formVersion?.rolls_out || []).reduce((acc, rollout) => {
                        const section = (rollout?.sections || []).find(s => s.form_version_id === formVersion._id);
                        const formOrderItem = formVersion.form[0].form_order_items.find(foi => foi.order_item_id === hit._id);

                        return acc + ((section?.repetition || 0) * (formOrderItem?.segment_repetition || 0));
                    }, 0);

                    return {
                        ...hit,
                        colorCode: QUALITY_BG_COLORS[`${border?.code === '0' ? '' : 'b'}${quality?.code}`],
                        name: (quality?.name[0]?.value || '') + borderName,
                        total_pieces: countJr > 0 ? countJr : count,
                    };
                }),
            }));
        }
    } catch (e) {
        console.log(e);
        yield put(loadReprintErr());
    }
}

// eslint-disable-next-line import/prefer-default-export
export function* loadReprintWatcher() {
    yield takeLatest(LOAD_REPRINT, loadReprintSaga);
}
// L O A D   P R E P R E S S


// I G N O R E   R E P R I N T
function* ignoreReprintSaga(action) {
    try {
        const { locale } = yield select(getLayout);

        const resultState = yield reprintStateApi({
            order_item_id: action.id,
            quantity: action.quantity,
            reprint_state: 'IGNORED',
        });

        if (resultState.status === 202) {
            yield put(ignoreReprintRes());
            yield put({ type: LOAD_REPRINT });
            setNotification('success', locale, 'global.success', 'global.success');
        } else {
            setNotification('error', locale, 'global.error', 'global.error');
        }
    } catch (e) {
        yield put(ignoreReprintErr());
    }
}

export function* ignoreReprintWatcher() {
    yield takeLatest(IGNORE_REPRINT, ignoreReprintSaga);
}
// I G N O R E   R E P R I N T
